export default "/images/6e630cf35780bf2967d99f5aa47b48ff.avif";